import { Link } from "react-router-dom";
import { resolveIcon } from "../utils/resolveIcon";

export default function Header() {
  return (
    <div className="invoice-banner">
      <div className="header-container">
        <Link to="/">
          <img
            src={resolveIcon("logo")}
            alt="Ehsibly"
            className="logo"
          />
        </Link>
      </div>
    </div>
  );
}
